<template>
	<div>
		<div class="content-header">
            <div class="content-header-left mb-2">
                <div class="breadcrumbs-top">
                    <h2 class="content-header-title mb-0">{{ title }}</h2>
                    <div class="breadcrumb-wrapper">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="role_id == 2 ? '/' : '/kontrak'">
                                    <i class="feather icon-home"></i>
                                </router-link>
                            </li>

                            <li class="breadcrumb-item" :class="data.active == true ? 'active' : ''" style="text-transform: capitalize" v-for="(data, index) in breadcumb" :key="index">
                                <router-link :to="data.link">{{ data.name }}</router-link>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section id="basic-datatable">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <ValidationObserver v-slot="{ invalid }" class="card-content">
                                <div class="card-content">
                                    <div class="card-body card-dashboard">
                                        <h3 class="font-bold text-primary mb-2">Edit CCTV</h3>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <ValidationProvider name="model.name" v-slot="{ errors }" rules="required">
                                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                        <label for="">Nama CCTV</label>
                                                        <input type="text" v-model="model.name" id="" class="form-control">
                                                    </div>
                                                </ValidationProvider>
                                            </div>

                                            <div class="col-md-6">
                                                <ValidationProvider name="model.url" v-slot="{ errors }" rules="">
                                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                        <label for="">URL CCTV</label>
                                                        <input type="text" v-model="model.url" id="" class="form-control">
                                                    </div>
                                                </ValidationProvider>
                                            </div>

                                            <div class="col-md-12">
                                                <ValidationProvider name="model.lokasi" v-slot="{ errors }" rules="required">
                                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                        <label for="">Lokasi CCTV</label>
                                                        <div class="row">
                                                            <div class="col-md-10">
                                                                <input type="text" class="form-control" v-model="lokasiInp[0].latlng" placeholder="Lokasi cctv (Latitude,Longitude)">
                                                                <input type="hidden" v-model="model.lokasi" class="form-control" placeholder="Masukan lokasi cctv" aria-describedby="helpId" required="">  
                                                            </div>
                                                            <div class="col-md-2">
                                                                <a href="javascript:;" @click="addMarker(0)"
                                                                    class="btn w-100 waves-effect waves-light" :class="(!lokasiInp[0].pinned)? 'btn-success-trans': 'btn-warning-trans'">
                                                                    <span v-if="!lokasiInp[0].pinned">
                                                                        Pin Lokasi
                                                                    </span>
                                                                    <span v-else><i class="fa fa-times"></i> Batal </span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <br>
                                                        <div class="w-100" id="map" ref="map" style="height:300px"></div>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-wrap justify-content-end align-items-center">
                                            <router-link to="/cctv" class="btn btn-outline-primary mr-1 btn-lg" data-dismiss="modal">Batal</router-link>
                                            <button @click="save()" :disabled="invalid" type="button" class="btn btn-primary btn-lg"
                                                data-dismiss="modal">Simpan</button>
                                        </div>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </section>
        </div>
	</div>
</template>

<script>
export default {
    name: "CCTVForm",
    data() {
        return {
            title: "CCTV",
            breadcumb: [
                {
                    name: 'CCTV',
                    link: '/cctv',
                    active: false
                },   
                {
                    name: 'Edit CCTV', 
                    link: '',
                    active: true
                }            
            ],
            model: [],
            map: '',
            marker : [],
            lokasiInp: [{
                    latlng : '',
                    pinned : false
            }],
            role_id: localStorage.getItem('role_id')
        }
    },
    methods: {
        get() {
            let _ = this
            _.axios.get('/cctv/' + _.$route.params.id)
                .then(resp=>{
                    _.model = resp.data.data
                })
                .catch(err=>{
                    console.log(err.response)
                })
        },
        save() {
            let _ = this
            if ( _.model.lokasi.length == 0 ) {
                _.$toast.warning('Pin lokasi terlebih dahulu')
                return;
            }

            _.axios.patch('/cctv/' + _.$route.params.id, _.model)
                .then(resp => {
                    if (resp.status) {
                        _.$router.push('/cctv')
                        _.$toast.success('Data Berhasil Diubah')
                    }else{
                        console.log("Failed")
                        _.$toast.warning('Data Gagal Diubah')
                    }
                })
                .catch(err=>{
                    console.log(err.response)
                    _.$toast.warning('Data Sub-Bidang Sudah Digunakan')
                })
        },
        initMap() {
            let _ = this
            var myLatlng = {lat: _.model.lat, lng: _.model.lng}
            _.map = new window.google.maps.Map(
               _.$refs["map"], {zoom: 12, center: myLatlng})
        },
        async addMarker(index) {
            let _ = this
            var mylatlng = {lat : parseFloat(_.lokasiInp[index].latlng.split(",")[0]), lng : parseFloat(_.lokasiInp[index].latlng.split(",")[1])}
            if(!_.lokasiInp[index].pinned){
                var geocoder = new window.google.maps.Geocoder();
                geocoder.geocode({
                        'latLng': mylatlng
                    }, function(results, status) {
                        if (status == window.google.maps.GeocoderStatus.OK) {
                            if (results[0]) {
                                let mark = new window.google.maps.Marker({
                                                map : _.map,
                                                animation: window.google.maps.Animation.DROP,
                                                position: {lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()}
                                            });
                                var infoWindow = new window.google.maps.InfoWindow({
                                    content: results[0].formatted_address,
                                });
                                _.marker['mark'+index] = mark
                                infoWindow.open(_.map, _.marker['mark'+index]);

                                _.model.lokasi[0] = {
                                    address: results[0].formatted_address,
                                    gmap_url : 'https://www.google.co.id/maps/place/'+results[0].formatted_address.replace(/,/g,"").replace(/ /g,"+"),
                                    lat : results[0].geometry.location.lat(),
                                    lng : results[0].geometry.location.lng()
                                }
                                _.lokasiInp[index].pinned = true
                            }
                        }
                    });
           
            }
            else{
                _.cancelPin(index)
            }
            
        },
        cancelPin(ix) {
            let _ = this
            _.model.lokasi = []
            _.marker['mark'+ix].setMap(null)
           delete _.marker['mark'+ix]
            _.lokasiInp[ix].latlng = ""
            _.lokasiInp[ix].pinned = false
        }
    },
    computed: {
        latlng() {
            let _ = this
            return _.model.lat + ', ' + _.model.lng
        }
    },
    mounted() {
        let _ = this
        _.get()
    },
    watch: {
        'model.lng': function(newValue) {
            let _ = this
            _.lokasiInp[0].latlng = _.model.lat + ', ' + newValue
            _.initMap()
            _.addMarker(0)
        }
    }
}
</script>